export interface AmbientContextState {
  operatorFocus: string | null;
  focusEpoch: number;
  ambientSource: string | null;
  segmentId: number;
}

export interface AmbientContextTransition extends AmbientContextState {
  changed: boolean;
  boundarySource: string | null;
}

/**
 * Advances the temporary Ambient narration source without changing the
 * operator's real focus. AiApi reserves focusEpoch for explicit navigation;
 * each Ambient boundary advances only segmentId.
 */
export function transitionAmbientContext(
  state: AmbientContextState,
  ambientSource: string | null,
): AmbientContextTransition {
  if (state.ambientSource === ambientSource) {
    return { ...state, changed: false, boundarySource: ambientSource };
  }
  return {
    ...state,
    ambientSource,
    segmentId: state.segmentId + 1,
    changed: true,
    boundarySource: ambientSource,
  };
}
